import { render, staticRenderFns } from "./BlogThree.vue?vue&type=template&id=28dd9da1&"
import script from "./BlogThree.vue?vue&type=script&lang=js&"
export * from "./BlogThree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28dd9da1')) {
      api.createRecord('28dd9da1', component.options)
    } else {
      api.reload('28dd9da1', component.options)
    }
    module.hot.accept("./BlogThree.vue?vue&type=template&id=28dd9da1&", function () {
      api.rerender('28dd9da1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/blogs/BlogThree.vue"
export default component.exports